import * as Sentry from '@sentry/react';
import { IS_DEV, IS_PROD } from '../utils/config';

if (IS_DEV) {
  Sentry.init({
    dsn: "https://86356d592564a59c2d8ba976431a2edc@o4508805582028800.ingest.de.sentry.io/4508805583470672",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api.dev.gogeta\.com\/api\/tech-platform\/v1/],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else if (IS_PROD) {
  Sentry.init({
    dsn: "https://43fec954df5e926ac62ced9287a2d480@o4508805591138304.ingest.de.sentry.io/4508805591924816",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api.gogeta\.com\/api\/tech-platform\/v1/],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}